import storage from 'good-storage';

const prefix = 'life_';
const life = {
    namespaced: true,
    state: {
        product_detail: null,
    },
    getters: {
        product_detail: state => {
            if (!state.product_detail) {
                let cached_product = localStorage.getItem(prefix + 'product_detail');
                if (cached_product) state.product_detail = JSON.parse(cached_product);
            }
            return state.product_detail;
        },
        product_insure_info: state => {
            if (!state.product_insure_info) {
                let cached_product_insure_info = localStorage.getItem(prefix + 'product_insure_info');
                if (cached_product_insure_info) state.product_insure_info = JSON.parse(cached_product_insure_info);
            }
            return state.product_insure_info;
        },
    },

    mutations: {
        set_product_detail: (state, product_detail) => {
            state.product_detail = product_detail;
            if (!product_detail) {
                localStorage.removeItem(prefix + 'product_detail');
            } else {
                localStorage.setItem(prefix + 'product_detail', JSON.stringify(product_detail));
            }
        },

        set_product_insure_info: (state, product_insure_info)  => {
            state.product_insure_info = product_insure_info;
            if (!product_insure_info) {
                localStorage.removeItem(prefix + 'product_insure_info');
            } else {
                localStorage.setItem(prefix + 'product_insure_info', JSON.stringify(product_insure_info));
            }
        },
    },

    actions: {}
};

export default life;
